import React, { Fragment, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiButton from "Components/MuiButton/MuiButton";
import {DialogActions, Grid} from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import millimeterMask from "Components/Input/components/millimeterMask";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import { GetAllTori, InsertToriData, changeToriSearch } from "Stores/actions";
import showNotify from "Helpers/Notify";
import { useTranslation } from 'react-i18next';
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function InsertTori() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const { toriDataPagination } = useSelector((state) => ({
    toriDataPagination: state.tori.toriDataPagination,
  }));
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: "",
      row: 1,
      validation: {
        required: true,
      },
      col: {
        xs: 12,
        sm: 6,
      },
    },
    priceTori: {
      type: "price",
      value: "",
      row: 1,
      validation: {
        required: true,
        isPrice: true,
        notZero: true
      },
      col: {
        xs: 12,
        sm: 6,
      },
    },
    incW: {
      type: "millimeter",
      value: "",
      row: 2,
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        notZero: true,
        allowMinus: true
      },
      col: {
        xs: 12,
        sm: 6,
      },
    },
    incH: {
      type: "millimeter",
      value: "",
      row: 2,
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        notZero: true,
        allowMinus: true
      },
      col: {
        xs: 12,
        sm: 6,
      },
    },
    MovableInc: {
      type: "millimeter",
      value: "",
      row: 3,
      validation: {
        required: true,
        isNumeric: true,
      },
      col: {
        xs: 12,
        sm: 6,
      },
    },
    MovableCount: {
      type: "number",
      value: "",
      row: 3,
      validation: {
        required: true,
        isNumeric: true,
        min: 0,
        max: 2,
      },
      col: {
        xs: 12,
        sm: 6,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const handleDialog = () => setOpenDialog(!openDialog);

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { name, priceTori, incW, incH, MovableInc, MovableCount } = controls;
    if (
      !R.isEmpty(formValid) && Object.values(formValid).every((item) => item === true)
    ) {
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Price: +priceTori.value,
          Name: name.value,
          incW: +incW.value,
          incH: +incH.value,
          movableInc: MovableInc.value,
          movableCount: MovableCount.value,
        };
        await dispatch(InsertToriData(data));
        dispatch(changeToriSearch({ Name: "" }));
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: toriDataPagination.Limit,
          Page: toriDataPagination.Page,
        };
        await dispatch(GetAllTori(params));
        onClear();
        handleDialog();
      } catch (e) {
        showNotify({
          text: t('correctFormDataRequired'),
          customClass: "error",
        });
      }
      handleDialog();
    } else {
      setCheckValid(true);
    }
    setLoading(false);
  };

  const onEnter = async () => {
    onClear();
  };

  const onClear = () => {
    setCheckValid(false);
    setFormValid({ name: false, priceTori: false, incW: false, incH: false });
    setControls({ name: { value: "" } });
    setControls({ incW: { value: "" } });
    setControls({ incH: { value: "" } });
    setControls({ MovableInc: { value: 0 } });
    setControls({ MovableCount: { value: 0 } });
    setControls({ priceTori: { value: "" } });
  };

  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"newNet"}/>}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <BackDropLoading loading={loading}/>
        <form onSubmit={onFinish} >
          <div className="dialogHeader">
            <p>{<Translator id={"addNewNet"}/>} </p>
          </div>
          <DialogContent style={{ overflow: "visible" }}>
            <Grid container spacing={2} className="mb-1 d-flex">
              {
                Object.keys(controls).filter(key => controls[key].row === 1).map((key, index) => {
                  return (
                    <Grid item className="flex-grow-1" key={key + index}>
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        placeholder={t(key)}
                        validation={controls[key].validation}
                        checkValid={checkValid}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        endIcon={controls[key].type === "price" ? <Translator id='moneyUnit' /> : ''}
                      />
                    </Grid>
                  );
                })
              }
            </Grid>
            <Grid container className="overflow-hidden">
              <Grid item xs={12} className="text-center py-2 mb-3" style={{backgroundColor: '#E4E8E8'}}>
                <strong><Translator id="netIncWH" noSpan/></strong>
              </Grid>
              <Grid container spacing={2}>
                {
                  Object.keys(controls).filter(key => controls[key].row === 2).map((key, index) => {
                    return (
                      <Grid item sm={controls[key].col.sm} xs={controls[key].col.xs} key={key + index}>
                        <Input
                          setValue={setValue.bind(this)}
                          name={key}
                          value={controls[key].value}
                          placeholder={t(key)}
                          validation={controls[key].validation}
                          checkValid={checkValid}
                          label={<Translator id={key} />}
                          type={controls[key].type}
                          endIcon={<Translator id='millimeter' />}
                          minLength={controls[key]?.validation?.minLength}
                          maxlength={controls[key]?.validation?.maxLength}
                          inputComponent={millimeterMask}
                        />
                      </Grid>
                    );
                  })
                }
              </Grid>
              <Grid item xs={12} className="text-center py-2 mb-3" style={{backgroundColor: '#E4E8E8'}}>
                <strong><Translator id="netMovable" noSpan/></strong>
              </Grid>
              <Grid container spacing={2}>
                {
                  Object.keys(controls).filter(key => controls[key].row === 3).map((key, index) => {
                    return (
                      <Grid item sm={controls[key].col.sm} xs={controls[key].col.xs} key={key + index}>
                        <Input
                          setValue={setValue.bind(this)}
                          name={key}
                          value={controls[key].value}
                          placeholder={t(key)}
                          validation={controls[key].validation}
                          checkValid={checkValid}
                          label={<Translator id={key} />}
                          type={controls[key].type}
                          endIcon={controls[key].type === "millimeter" ? <Translator id='millimeter' /> : ''}
                          inputComponent={controls[key].type === "millimeter" && millimeterMask}
                        />
                      </Grid>
                    );
                  })
                }
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default InsertTori;
